@import "~@govbr-ds/core/src/components/table/table";

:host {
  display: block;
  width: 100%;
}

.br-table {
  display: grid;
  grid-template-columns: 1fr;
}
